import { useState, useEffect, createContext } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';

import { useRouter, usePathname } from 'src/routes/hooks';

import { useResponsive } from 'src/hooks/use-responsive';

import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { NavSectionVertical } from 'src/components/nav-section';

import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { useAuthContext } from '../../auth/hooks';

// ----------------------------------------------------------------------
export const NavNotificationContext = createContext<string[]>([]);
// export const useNavNotifications = () => useContext(NavNotificationContext);

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { user } = useAuthContext();
  const router = useRouter();
  const pathname = usePathname();
  const lgUp = useResponsive('up', 'lg');
  const [navNotifications, setNavNotifications] = useState<string[]>([]);

  useEffect(() => {
    console.log('getting nav notifications...')
    setNavNotifications(["Profile"]);
  }, [])



  const navData = useNavData().filter((section) => {
    // Ensure user is not null and user.roles is an array
    if (user && Array.isArray(user.roles)) {
      return section.roles.some((role: string) => user.roles.includes(role));
    }
    return false;
  });

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100vh',
        maxHeight: '100vh',
        overflow: 'auto',
        // Hide scrollbars
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        '&': {
          '-ms-overflow-style': 'none', // IE and Edge
          'scrollbar-width': 'none', // Firefox
        },
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
          minHeight: 'fit-content',
        },
        '& .simplebar-track.simplebar-vertical': {
          display: 'none',
        },
        '& .simplebar-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Logo sx={{ mt: 3, ml: 4, mb: 1 }} onClick={() => router.replace('/dashboard')} />


      <NavSectionVertical
        // TODO: fix config-navigation and all of these
        // @ts-ignore
        data={navData}
        slotProps={{
          currentRole: user?.role,
        }}
      />
    </Scrollbar>
  );

  return (
    <NavNotificationContext.Provider value={navNotifications}>
      <Box
        sx={{
          flexShrink: { lg: 0 },
          width: { lg: NAV.W_VERTICAL },
        }}
      >
        {/* <NavToggleButton /> */}

        {lgUp ? (
          <Stack
            sx={{
              height: '100vh',
              maxHeight: '100vh',
              position: 'fixed',
              width: NAV.W_VERTICAL,
              borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
              overflow: 'hidden',
            }}
          >
            {renderContent}
          </Stack>
        ) : (
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            PaperProps={{
              sx: {
                width: NAV.W_VERTICAL,
              },
            }}
          >
            {renderContent}
          </Drawer>
        )}
      </Box>
    </NavNotificationContext.Provider>

  );
}
